import { render, staticRenderFns } from "./AccordionEdit.vue?vue&type=template&id=89af31de&"
import script from "./AccordionEdit.vue?vue&type=script&lang=js&"
export * from "./AccordionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports